// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"0757dede","453":"d8806da3"}[chunkId] + ".chunk.js";
};